export default __webpack_public_path__ + "static/property-img-4_768-f3686cc567340ee7cabce98b66e32812.jpg";